const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgCorpbanca(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f8d5b0e5-341d-4ccb-a788-d7d66ab2a6e6",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bc5cd140-4ff2-4c8d-b91d-af6bcb801903{fill:#0078c4;}.fdea4193-ff6b-4143-8b55-40017e557d35{fill:#fff;stroke:#0078c4;stroke-miterlimit:10;stroke-width:0.3px;}")), /*#__PURE__*/React.createElement("rect", {
    className: "bc5cd140-4ff2-4c8d-b91d-af6bcb801903",
    width: 52,
    height: 52,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "fdea4193-ff6b-4143-8b55-40017e557d35",
    d: "M11.43,22.7c.1-.38.16-.73.27-1.06,1.78-5.31,5.32-8.82,10.77-10.17a14.55,14.55,0,0,1,12.86,2.79c.49.39.49.4.19.92l-4.17,7.24a.55.55,0,0,1-.55.32H11.86C11.74,22.74,11.62,22.72,11.43,22.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fdea4193-ff6b-4143-8b55-40017e557d35",
    d: "M36.24,15c.69.8,1.35,1.48,1.91,2.24a14.16,14.16,0,0,1,2.76,6.94,14.72,14.72,0,0,1-3,11.06A15,15,0,0,1,31.49,40c-.31.12-.53.17-.74-.2-1.39-2.45-2.8-4.88-4.21-7.31a.65.65,0,0,1,0-.75Q31,24.08,35.4,16.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fdea4193-ff6b-4143-8b55-40017e557d35",
    d: "M30.43,40.37c-.9.19-1.69.41-2.51.5A14.91,14.91,0,0,1,11.24,28.81a15,15,0,0,1-.08-5.13c0-.3.14-.45.49-.44q4.24,0,8.49,0a.63.63,0,0,1,.65.37q2.25,3.93,4.52,7.84,2.4,4.17,4.81,8.35C30.21,40,30.29,40.1,30.43,40.37Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorpbanca);
export default __webpack_public_path__ + "static/media/CORPBANCA.ec945e30ae9f670a88a8cb6d74bb2ebc.svg";
export { ForwardRef as ReactComponent };